import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import './valveSystem.css';
import { openFeedbackFor } from './valveFeedback';

/**
 * ValvePopup — reproduces mock/FINAL-valve-popup.html (approved 9-10-26).
 *
 * Shape (locked): raw pulsing burrow mark · "We're making improvements." ·
 * "It will be available again soon." · ONE Check status button (→ the door /
 * status page) · "If it doesn't look right to you, let us know." No list, no
 * dates, no area names. Dismissible with ✕ / Esc / backdrop.
 *
 * Props: { onClose } — parent controls visibility (renders null when closed).
 */

const ValvePopup = ({ onClose }) => {
  const navigate = useNavigate();
  const popRef = useRef(null);

  // Esc closes
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose && onClose(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onClose]);

  // Focus the sheet so Esc works even before any click
  useEffect(() => { if (popRef.current) popRef.current.focus(); }, []);

  const goStatus = () => {
    if (onClose) onClose();
    navigate('/status', { replace: true });
  };

  return (
    <div
      className="vs-popup-ov"
      onClick={(e) => { if (e.target === e.currentTarget && onClose) onClose(); }}
    >
      <div
        className="vs-popup-sheet"
        tabIndex={-1}
        ref={popRef}
        role="dialog"
        aria-modal="true"
        aria-label="Burrow notice"
      >
        <button className="vs-popup-x" aria-label="Close" onClick={onClose}>✕</button>
        <img className="vs-popup-mark" src={`${process.env.PUBLIC_URL}/media/burrow-solo-black.svg`} alt="" />
        <h2>We're making improvements.</h2>
        <p className="vs-popup-soon">It will be available again soon.</p>
        <div className="vs-popup-acts">
          <button className="vs-btn vs-btn-p" onClick={goStatus}>Check status</button>
        </div>
        <p className="vs-popup-quiet">If it doesn't look right to you, <button type="button" className="vs-link" onClick={() => { if (onClose) onClose(); openFeedbackFor('An area I tried to use is being improved'); }}>let us know</button></p>
      </div>
    </div>
  );
};

export default ValvePopup;
